import { getCookie } from "../../../../utils/cookie";
import apiRequest from "../../../../utils/apiClient";
import { updateMyCreationDescriptionUrl } from "../../../constants";

export const renameCreation = async (
  creationId: number,
  newTitle: string,
  messageStore: any,
  newDescription?: string,
): Promise<boolean> => {
  const body = new FormData();
  body.append("creation_id", creationId.toString());
  body.append("title", newTitle);
  if (newDescription !== undefined) body.append("description", newDescription);

  try {
    const response = await apiRequest(updateMyCreationDescriptionUrl, {
      method: "POST",
      mode: "cors",
      body,
      headers: { "X-CSRFToken": getCookie("csrftoken") },
    });
    if (response.status === 401) {
      messageStore.setMessage("Authentication failed. Please log in again.", "error");
      return false;
    }
    const data = await response.json();
    if (response.ok && data.message === "success") return true;
    messageStore.setMessage(`Error renaming creation: ${data.message || "Unknown error"}`, "error");
    return false;
  } catch (error: any) {
    messageStore.setMessage(`Network error: ${error.message}`, "error");
    return false;
  }
};
